/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      username
      displayName
      bio
      avatarUrl
      createdAt
      updatedAt
    }
  }
`;

export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        displayName
        bio
        avatarUrl
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getCharactersByUser = /* GraphQL */ `
  query GetCharactersByUser($userId: ID!) {
    getCharactersByUser(userId: $userId) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getFriendRequests = /* GraphQL */ `
  query GetFriendRequests($userId: ID!) {
    getFriendRequests(userId: $userId) {
      id
      senderId
      receiverId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const getFriends = /* GraphQL */ `
  query GetFriends($userId: ID!) {
    getFriends(userId: $userId) {
      id
      user1Id
      user2Id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const getCharacter = /* GraphQL */ `
  query GetCharacter($id: ID!) {
    getCharacter(id: $id) {
      id
      name
      characterClass
      race
      level
      experience
      maxHealth
      currentHealth
      gold
      strength
      dexterity
      constitution
      intelligence
      wisdom
      charisma
      armorClass
      speed
      initiative
      proficiencyBonus
      alignment
      backstory
      notes
      owner
      items {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      campaignProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCharacters = /* GraphQL */ `
  query ListCharacters(
    $filter: ModelCharacterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCharacters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlogPost = /* GraphQL */ `
  query GetBlogPost($id: ID!) {
    getBlogPost(id: $id) {
      id
      title
      content
      excerpt
      author
      publishDate
      svgContent
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBlogPosts = /* GraphQL */ `
  query ListBlogPosts(
    $filter: ModelBlogPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBlogPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        content
        excerpt
        author
        publishDate
        svgContent
        iconName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBadge = /* GraphQL */ `
  query GetBadge($id: ID!) {
    getBadge(id: $id) {
      id
      name
      description
      imageUrl
      achievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listBadges = /* GraphQL */ `
  query ListBadges(
    $filter: ModelBadgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBadges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        imageUrl
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAchievement = /* GraphQL */ `
  query GetAchievement($id: ID!) {
    getAchievement(id: $id) {
      id
      name
      description
      rewardXP
      rewardGold
      rewardBadge {
        id
        name
        description
        imageUrl
        createdAt
        updatedAt
        owner
        __typename
      }
      characterAchievements {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      badgeAchievementsId
      owner
      __typename
    }
  }
`;
export const listAchievements = /* GraphQL */ `
  query ListAchievements(
    $filter: ModelAchievementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAchievements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        rewardXP
        rewardGold
        createdAt
        updatedAt
        badgeAchievementsId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCharacterAchievement = /* GraphQL */ `
  query GetCharacterAchievement($id: ID!) {
    getCharacterAchievement(id: $id) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      achievement {
        id
        name
        description
        rewardXP
        rewardGold
        createdAt
        updatedAt
        badgeAchievementsId
        owner
        __typename
      }
      achievementId
      dateUnlocked
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listCharacterAchievements = /* GraphQL */ `
  query ListCharacterAchievements(
    $filter: ModelCharacterAchievementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCharacterAchievements(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        achievementId
        dateUnlocked
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterAchievementsByCharacterId = /* GraphQL */ `
  query CharacterAchievementsByCharacterId(
    $characterId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterAchievementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterAchievementsByCharacterId(
      characterId: $characterId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        achievementId
        dateUnlocked
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterAchievementsByAchievementId = /* GraphQL */ `
  query CharacterAchievementsByAchievementId(
    $achievementId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterAchievementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterAchievementsByAchievementId(
      achievementId: $achievementId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        achievementId
        dateUnlocked
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      description
      startDate
      endDate
      characterProgresses {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        startDate
        endDate
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCharacterCampaignProgress = /* GraphQL */ `
  query GetCharacterCampaignProgress($id: ID!) {
    getCharacterCampaignProgress(id: $id) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      campaign {
        id
        name
        description
        startDate
        endDate
        createdAt
        updatedAt
        owner
        __typename
      }
      campaignId
      currentChapter
      completedQuests
      notes
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listCharacterCampaignProgresses = /* GraphQL */ `
  query ListCharacterCampaignProgresses(
    $filter: ModelCharacterCampaignProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCharacterCampaignProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        campaignId
        currentChapter
        completedQuests
        notes
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterCampaignProgressesByCharacterId = /* GraphQL */ `
  query CharacterCampaignProgressesByCharacterId(
    $characterId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterCampaignProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterCampaignProgressesByCharacterId(
      characterId: $characterId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        campaignId
        currentChapter
        completedQuests
        notes
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterCampaignProgressesByCampaignId = /* GraphQL */ `
  query CharacterCampaignProgressesByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterCampaignProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterCampaignProgressesByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        campaignId
        currentChapter
        completedQuests
        notes
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSkill = /* GraphQL */ `
  query GetSkill($id: ID!) {
    getSkill(id: $id) {
      id
      name
      description
      characterSkills {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listSkills = /* GraphQL */ `
  query ListSkills(
    $filter: ModelSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCharacterSkill = /* GraphQL */ `
  query GetCharacterSkill($id: ID!) {
    getCharacterSkill(id: $id) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      skill {
        id
        name
        description
        createdAt
        updatedAt
        owner
        __typename
      }
      skillId
      level
      experience
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listCharacterSkills = /* GraphQL */ `
  query ListCharacterSkills(
    $filter: ModelCharacterSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCharacterSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        characterId
        skillId
        level
        experience
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterSkillsByCharacterId = /* GraphQL */ `
  query CharacterSkillsByCharacterId(
    $characterId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterSkillsByCharacterId(
      characterId: $characterId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        skillId
        level
        experience
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterSkillsBySkillId = /* GraphQL */ `
  query CharacterSkillsBySkillId(
    $skillId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterSkillsBySkillId(
      skillId: $skillId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        skillId
        level
        experience
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getItem = /* GraphQL */ `
  query GetItem($id: ID!) {
    getItem(id: $id) {
      id
      name
      description
      type
      rarity
      value
      characterItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listItems = /* GraphQL */ `
  query ListItems(
    $filter: ModelItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        type
        rarity
        value
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCharacterItem = /* GraphQL */ `
  query GetCharacterItem($id: ID!) {
    getCharacterItem(id: $id) {
      id
      character {
        id
        name
        characterClass
        race
        level
        experience
        maxHealth
        currentHealth
        gold
        strength
        dexterity
        constitution
        intelligence
        wisdom
        charisma
        armorClass
        speed
        initiative
        proficiencyBonus
        alignment
        backstory
        notes
        owner
        createdAt
        updatedAt
        __typename
      }
      characterId
      item {
        id
        name
        description
        type
        rarity
        value
        createdAt
        updatedAt
        owner
        __typename
      }
      itemId
      quantity
      isEquipped
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listCharacterItems = /* GraphQL */ `
  query ListCharacterItems(
    $filter: ModelCharacterItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCharacterItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        characterId
        itemId
        quantity
        isEquipped
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterItemsByCharacterId = /* GraphQL */ `
  query CharacterItemsByCharacterId(
    $characterId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterItemsByCharacterId(
      characterId: $characterId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        itemId
        quantity
        isEquipped
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const characterItemsByItemId = /* GraphQL */ `
  query CharacterItemsByItemId(
    $itemId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCharacterItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    characterItemsByItemId(
      itemId: $itemId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        characterId
        itemId
        quantity
        isEquipped
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFriendRequest = /* GraphQL */ `
  query GetFriendRequest($id: ID!) {
    getFriendRequest(id: $id) {
      id
      senderId
      receiverId
      status
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listFriendRequests = /* GraphQL */ `
  query ListFriendRequests(
    $filter: ModelFriendRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFriendRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        senderId
        receiverId
        status
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFriendship = /* GraphQL */ `
  query GetFriendship($id: ID!) {
    getFriendship(id: $id) {
      id
      user1Id
      user2Id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listFriendships = /* GraphQL */ `
  query ListFriendships(
    $filter: ModelFriendshipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFriendships(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user1Id
        user2Id
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getGameModule = /* GraphQL */ `
  query GetGameModule($id: ID!) {
    getGameModule(id: $id) {
      id
      name
      description
      scenes
      createdAt
      updatedAt
    }
  }
`;

export const getGameState = /* GraphQL */ `
  query GetGameState($gameId: ID!, $characterId: ID!) {
    getGameState(gameId: $gameId, characterId: $characterId) {
      id
      gameId
      characterId
      currentScene
      state
      createdAt
      updatedAt
    }
  }
`;
